const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const cleanString = (value) =>
  typeof value === "string" ? value.trim() : "";

const isEmailLike = (value) => EMAIL_PATTERN.test(cleanString(value));

const normalizeEmail = (email, fallbackDisplayName) => {
  const cleanedEmail = cleanString(email);
  if (cleanedEmail) return cleanedEmail.toLowerCase();

  const cleanedDisplayName = cleanString(fallbackDisplayName);
  if (isEmailLike(cleanedDisplayName)) {
    return cleanedDisplayName.toLowerCase();
  }

  return "";
};

const capitalizeWord = (word) =>
  word ? word[0].toUpperCase() + word.slice(1) : "";

export const deriveDisplayNameFromEmail = (email) => {
  const localPart = normalizeEmail(email).split("@")[0];
  if (!localPart) return "User";

  const words = localPart
    .split(/[._+-]+/)
    .map((word) => word.trim())
    .filter(Boolean)
    .map(capitalizeWord);

  return words.length ? words.join(" ") : "User";
};

export const normalizeUserProfile = (profile) => {
  if (!profile) return null;

  const rawDisplayName = cleanString(profile.displayName);
  const email = normalizeEmail(profile.email, rawDisplayName);
  const displayNameLooksLikeEmail = isEmailLike(rawDisplayName);
  const displayNameMatchesEmail =
    displayNameLooksLikeEmail &&
    email &&
    rawDisplayName.toLowerCase() === email;

  const displayName =
    rawDisplayName && !displayNameMatchesEmail && !(!email && displayNameLooksLikeEmail)
      ? rawDisplayName
      : deriveDisplayNameFromEmail(email);

  return {
    ...profile,
    email,
    displayName,
  };
};

export const getUserDisplayName = (profile) =>
  normalizeUserProfile(profile)?.displayName || "User";

export const getUserFirstName = (profile) =>
  getUserDisplayName(profile).split(/\s+/)[0] || "there";

export const getUserInitials = (profile) => {
  const displayName = getUserDisplayName(profile);
  const parts = displayName.split(/\s+/).filter(Boolean);

  if (parts.length <= 1) {
    return parts[0]?.slice(0, 2).toUpperCase() || "U";
  }

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};
